const updateLetter = () => {
  const $element = document.querySelector(
    "[theme-product-letter]"
  ) as HTMLElement;
  // get search params with key "letter"
  const url = new URLSearchParams(window.location.search);
  let letter = url.get("letter")?.toLowerCase();
  if (!$element) {
    return;
  }
  if (!letter) {
    letter = "a";
  }

  // update images

  const $imgs = $element.querySelectorAll(
    `.composite-letter-image__img.letter__${letter}`
  );
  $imgs.forEach(($img) => {
    $img.classList.remove("is-hidden");
  });

  // update line item property

  const $btn = $element.querySelector<HTMLElement>(".regular-atc-btn");
  if ($btn) {
    $btn.dataset.property = `Lettre/${letter.toUpperCase()}`;
  }

  // update label
  const $label = $element.querySelector<HTMLElement>(".letter-label");
  if ($label) {
    $label.innerHTML = letter.toUpperCase();
  }

  // linked products

  const $linkedProducts =
    $element.querySelectorAll<HTMLElement>(`.linked-product`);
  $linkedProducts.forEach(($item) => {
    const url = $item.dataset.url;
    if (url) {
      $item.addEventListener("click", () => {
        window.location.href = `${url}?letter=${letter}`;
      });
    }
  });

  // active letter swatch

  const $letterSwatches = $element.querySelectorAll<HTMLElement>(
    `.product-options-form__letter`
  );
  $letterSwatches.forEach(($swatch) => {
    const swatchLetter = $swatch.dataset.letter;
    if (swatchLetter === letter) {
      $swatch.classList.add("active");
      // if active letter is sold out, add class tw-hidden to the atc button
      if ($swatch.classList.contains("not-available")) {
        $btn?.classList.add("tw-hidden");
        document
          .querySelector<HTMLElement>(".product-form__atc-button-soldout")
          ?.classList.remove("tw-hidden");
      } else {
        $btn?.classList.remove("tw-hidden");
        document
          .querySelector<HTMLElement>(".product-form__atc-button-soldout")
          ?.classList.add("tw-hidden");
      }
    }
  });
};

export default updateLetter;
